/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'yesCircle': {
    width: 16,
    height: 16,
    viewBox: '0 0 23.25 23.09',
    data: '<defs/><path pid="0" class="cls-1" d="M11.63 22.54a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-8.99z"/><path pid="1" class="cls-1" d="M16.68 8a1.1 1.1 0 0 0-1.49 0l-4.94 4.9-2.18-2.22a1.06 1.06 0 0 0-1.49 1.49L9.5 15.1a1.12 1.12 0 0 0 .75.32 1.63 1.63 0 0 0 .39-.06 1 1 0 0 0 .36-.26l5.65-5.65a1 1 0 0 0 0-1.49zm0 0"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/yesCircle.js